module.exports = __webpack_public_path__ + "static/media/Restaurant information.10739f14.png";